import React from 'react';

import { useSwitchStyles } from './Switch.styles';
import clsx from 'clsx';
import { Label } from 'components/UI/V2/Forms/Label/Label';

type SwitchProps = Omit<React.ComponentProps<'input'>, 'onChange'> & {
    label?: string;
    inlineLabel?: string;
    onChange?: (checked: boolean) => void;
};

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(({ label, inlineLabel, ...inputProps }, ref) => {
    const classes = useSwitchStyles();

    return (
        <div className={classes.root}>
            {label && <Label>{label}</Label>}

            <div className={classes.switchContainer}>
                {inlineLabel && <span className={classes.inlineLabel}>{inlineLabel}</span>}

                <div
                    className={clsx(classes.switch, {
                        [classes.checked]: inputProps.checked,
                        [classes.disabled]: inputProps.disabled
                    })}
                >
                    <span
                        className={clsx(classes.slide, {
                            [classes.slideChecked]: inputProps.checked
                        })}
                    ></span>
                    <input
                        ref={ref}
                        {...inputProps}
                        className={classes.input}
                        onChange={event => inputProps.onChange?.(event.target.checked)}
                        type="checkbox"
                    />
                </div>
            </div>
        </div>
    );
});

Switch.displayName = 'Switch';

export { Switch };
